import Component from './TikTokPostTable.vue'
export default Component
